import { normalizeCountryCode } from "@/lib/location/visitorCountry";

export const getSupportedEducationCountries = (): string[] => (
  process.env.NEXT_PUBLIC_EDUCATION_DISCOVERY_COUNTRIES ?? "GB"
).split(",").map(normalizeCountryCode).filter((country): country is string => country !== null);